"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddZXGBtn = void 0;
var react_1 = __importStar(require("react"));
require("./index.less");
/**
 * 加自选按钮
 * @returns
 */
// export function AddZXGBtn(props: {
//   quotecode: string,
//   zxlist?: any
// }) {
//   let [addstatus, setStatus] = useState(false)
//   useEffect(() => {
//     let zxlist = props.zxlist?.result?.list || [];
//     let hasAdd = zxlist.some((v: string) => v == props.quotecode)
//     setStatus(hasAdd)
//   }, [props.quotecode])
//   let addZX = async () => {
//     let res = await addZXGStock(props.quotecode)
//     if (res.re) {
//       setStatus(true)
//     }
//   }
//   let delZX = async () => {
//     let res = await deleteZXGStock(props.quotecode)
//     if (res.re) {
//       setStatus(false)
//     }
//   }
//   console.log(props.zxlist?.result?.list)
//   return (<>
//     {
//       addstatus && <span className="delzxgbtn" title="删自选" onClick={delZX}>
//         <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAADAQMAAAB7xLc1AAAAA1BMVEX///+nxBvIAAAACklEQVQI12OAAQAACQABJogmYAAAAABJRU5ErkJggg==" alt="-" />
//       </span>
//     }
//     {
//       !addstatus && <span className="addzxgbtn" title="加自选" onClick={addZX}>
//         <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDkvMjEvMjPiBqWOAAAAJ0lEQVQYlWP8//8/AxJA5jDCGEwMRACiFLGgWYHVaupax4jEp7HvACPbBxJ5fg7UAAAAAElFTkSuQmCC" alt="+"></img>
//       </span>
//     }
//   </>)
// }
var mobx_1 = require("mobx");
var mobx_react_lite_1 = require("mobx-react-lite");
var observe_1 = require("./observe");
/**
 * 增删自选按钮 0.300059
 * @param props
 * @returns
 */
function AddZxgBtn(props) {
    var _this = this;
    var _a, _b;
    var _c = (0, react_1.useState)(false), addstatus = _c[0], setStatus = _c[1];
    if (observe_1.observedata == null)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var oblist = (0, mobx_1.toJS)((_b = (_a = observe_1.observedata === null || observe_1.observedata === void 0 ? void 0 : observe_1.observedata.zxgdata) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.list);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var zxlist = ((_b = (_a = observe_1.observedata === null || observe_1.observedata === void 0 ? void 0 : observe_1.observedata.zxgdata) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.list) || [];
        var hasAdd = zxlist.some(function (v) { return v == props.quotecode; });
        setStatus(hasAdd);
    }, [props.quotecode, oblist]);
    /** 加 */
    var addZX = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    return [4 /*yield*/, observe_1.observedata.addZXG(props.quotecode)];
                case 1:
                    res = _a.sent();
                    if (res.re) {
                        setStatus(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    /** 删 */
    var delZX = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    return [4 /*yield*/, observe_1.observedata.cancelZXG(props.quotecode)];
                case 1:
                    res = _a.sent();
                    if (res.re) {
                        setStatus(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        addstatus && react_1.default.createElement("span", { className: "delzxgbtn", title: "\u5220\u81EA\u9009", onClick: function (e) { delZX(e); } },
            react_1.default.createElement("img", { src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAADAQMAAAB7xLc1AAAAA1BMVEX///+nxBvIAAAACklEQVQI12OAAQAACQABJogmYAAAAABJRU5ErkJggg==", alt: "-" })),
        !addstatus && react_1.default.createElement("span", { className: "addzxgbtn", title: "\u52A0\u81EA\u9009", onClick: function (e) { addZX(e); } },
            react_1.default.createElement("img", { src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDkvMjEvMjPiBqWOAAAAJ0lEQVQYlWP8//8/AxJA5jDCGEwMRACiFLGgWYHVaupax4jEp7HvACPbBxJ5fg7UAAAAAElFTkSuQmCC", alt: "+" }))));
}
exports.AddZXGBtn = (0, mobx_react_lite_1.observer)(AddZxgBtn);
